import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";

import List from "../../../../../../components/DraggableList";
import SvgArrowUpDown from "../../../../../../components/SVG/ArrowUpDown";
import SvgDownload from "../../../../../../components/SVG/Download";
import Song from "../Songs";
import Button from "../../../../../../components/Button";
import Ok from "../../../../../../components/SVG/Ok";
import Trash from "../../../../../../components/SVG/Trash";
import SvgEdit from "../../../../../../components/SVG/Edit";
import SvgPlus from "../../../../../../components/SVG/Plus";
import SvgSearch from "../../../../../../components/SVG/Search";
import SvgMinusCircle from "../../../../../../components/SVG/MinusCircle";
import Save from "../../../../../../components/SVG/Save";

import ElementsGroup from "../../../../../../components/ElementsGroup";
import ButtonCircle from "../../../../../../components/ButtonCircle";
import { openModal } from "../../../../../../store/Modal/actions";

import {
  showAlertSuccess,
  showAlertError,
} from "../../../../../../store/Alert/actions";
import {
  toggleSelectedVideo,
  addVideoToList,
  sortVideos,
  downloadVideos,
  sortVideosCurrent,
  updateVideosPositions,
  deleteVideosFromVideoList,
} from "../../../../../../store/ContentVideolists/actions";
import { getNextSelected } from "../../../../../../utilities/getNextSelected";
import { isMobile } from "../../../../../../utilities/media";
import { debounce } from "../../../../../../utilities/debounce";
import Header from "./Header";

function truncateString(str) {
  if (str.length > 28) {
    return str.substring(0, 25) + "...";
  }
  return str;
}

const CurrentVideoList = forwardRef(
  ({ audio, trackPlaying, isPlaying, hPlay, hPause, hStop, hRewind }, ref) => {
    const dispatch = useDispatch();

    // Получаем данные из store с помощью useSelector
    const {
      songs,
      currentVideolist,
      selectedVideolists,
      selected_video,
      searched_value_ref,
    } = useSelector((state) => ({
      songs: state.videolists.songs,
      currentVideolist: state.videolists.currentVideolist,
      selectedVideolists: [...state.videolists.selected],
      selected_video: state.videolists.selected_video,
      searched_value_ref: state.search.songs.value,
    }));

    const [searched_value, setSearchedValue] = useState("");
    const [videolist_items, setVideolistItems] = useState([]);
    const [disableSearch, setDisableSearch] = useState(false);

    const getVideolistItems = () => [...(videolist_items || [])];

    useImperativeHandle(ref, () => ({
      getVideolistItems,
      setVideolistItems,
    }));

    const updateSearch = React.useCallback(
      debounce((value) => {
        setSearchedValue(value);
      }, 2000),
      []
    );

    React.useEffect(
      searched_value_ref !== ""
        ? () => {
          updateSearch(searched_value_ref);
        }
        : () => setSearchedValue(searched_value_ref),
      [searched_value_ref]
    );

    useEffect(() => {
      setVideolistItems(
        searched_value && !disableSearch
          ? songs.filter(
            (item) =>
              item["name"]
                .toLowerCase()
                .indexOf(searched_value.toLowerCase()) !== -1
          )
          : songs || []
      );
    }, [songs, searched_value, disableSearch]);

    useEffect(() => {
      if (currentVideolist) dispatch(sortVideosCurrent());
    }, [currentVideolist]);

    const sort = (type) => {
      dispatch(
        sortVideosCurrent({
          sort_field: type,
        })
      );
    };

    const save = () => {
      dispatch(
        updateVideosPositions({
          videolist_id: selectedVideolists[0],
          turn: songs.map((song) => song.id),
        })
      );
    };

    const selectAllS = (e) => {
      let songs_ids = currentVideolist?.songs.map((song) => {
        return Number(song.id);
      });
      songs_ids.forEach((id) => {
        if (
          selected_video.length ===
          Object.values(currentVideolist?.songs).length
        ) {
          dispatch(
            toggleSelectedVideo({
              id_video: id,
              onlyOne: songs_ids.indexOf(id) === -1 ? true : false,
            })
          );
        } else {
          if (selected_video.indexOf(id) === -1) {
            dispatch(
              toggleSelectedVideo({
                id_video: id,
                onlyOne: songs_ids.indexOf(id) === -1 ? true : false,
              })
            );
          }
        }
      });
    };

    const toggleSelectedS = ({ }, e) => {
      const songTitle = e.target;
      if (songTitle) {
        const songId = Number(
          songTitle.dataset.songId ||
          songTitle.parentNode.dataset.songId ||
          songTitle.parentNode.parentNode.dataset.songId
        );
        if (!isNaN(songId)) {
          const selected = getNextSelected({
            multiple: true,
            items: videolist_items,
            itemId: songId,
            selected: selected_video,
            ctrlKey: isMobile() || e.ctrlKey || e.metaKey,
            shiftKey: e.shiftKey,
          });
          dispatch(
            toggleSelectedVideo({
              id_video: selected,
              setAll: true,
            })
          );
        }
      }
    };

    const renderItem = (song, index) => ({
      id: song.id,
      name: song.name,
      element: (
        <Song
          key={song.id}
          id={song.id}
          name={song.name}
          turn={song.turn}
          cliptime={song.cliptime}
          selected={selected_video}
          tempo={song.tempo}
          ctime={song.ctime}
          songauthor_name={song.songauthor_name}
          player_name={song.player_name}
          album_name={song.album_name}
          genre_name={song.genre_name}
          year={song.year}
          variant={index % 2 == 0 ? "gray" : ""}
          filename={song.filename}
          audio={audio}
          mimetype={song.mimetype}
          trackPlaying={trackPlaying}
          isPlaying={isPlaying}
          play={hPlay}
          pause={hPause}
          stop={hStop}
          rewind={hRewind}
        />
      ),
    });

    const getItems = () => {
      return videolist_items.map(renderItem);
    };

    const deleteVideos = () => {
      console.log("@@!", { videoListId: selectedVideolists[0], ids_to_delete: selected_video });


      dispatch(deleteVideosFromVideoList({ videoListId: selectedVideolists[0], ids_to_delete: selected_video }))

      // let clear = songs
      //   .map((song) => song.id)
      //   .filter((id) => selected_video.indexOf(id) === -1);
      // let videolist_items_update = Array.from(videolist_items).filter(
      //   (song) => selected_video.indexOf(song.id) === -1
      // );
      // setVideolistItems([...videolist_items_update]);
      // dispatch(
      //   addVideoToList({
      //     id_videolist: selectedVideolists[0],
      //     selected_song: clear,
      //     songs: videolist_items_update,
      //   })
      // );
    };

    const sameArrays = useMemo(() => {
      const currentIds = videolist_items?.map((el) => el.id) || [];
      const refIds = songs.map((el) => el.id);

      console.log({ currentIds, refIds });

      // Сравниваем длину
      if (currentIds.length !== refIds.length) return false;
      // Сравниваем каждый элемент (порядок важен!)
      return currentIds.every((id, index) => id === refIds[index]);
    }, [videolist_items, songs]);

    const savePlaylistPosition = () => {
      dispatch(
        updateVideosPositions({
          videolist_id: currentVideolist.id,
          turn: videolist_items.map((song) => {
            return song.id;
          }),
        })
      );
    };

    return (
      <div className="Songs_collapsible" style={{ marginTop: 0 }}>
        {currentVideolist && selectedVideolists.length === 1 && (
          <>
            <h3>Видео список</h3>

            <h3>{`"${truncateString(currentVideolist.name)}"`}</h3>

            <div>
              <ElementsGroup position="right">
                <Button
                  type="string"
                  disabled={sameArrays}
                  onClick={savePlaylistPosition}
                >
                  <Save /> Сохранить порядок
                </Button>
                <ButtonCircle
                  className="plus"
                  disabled={false}
                  onClick={() => dispatch(openModal({ type: "videoCreate" }))}
                >
                  <SvgPlus />
                </ButtonCircle>

                <Button
                  type="string"
                  disabled={
                    selected_video[0] && !selected_video[1] ? false : true
                  }
                  onClick={() => {
                    let video = videolist_items.find(
                      (item) => item.id === selected_video[0]
                    );
                    dispatch(
                      openModal({
                        type: "videoEdit",
                        data: { video },
                      })
                    );
                  }}
                >
                  <SvgEdit /> Редактировать
                </Button>

                <Button
                  type="string"
                  disabled={selected_video.length > 0 ? false : true}
                  onClick={deleteVideos}
                >
                  <Trash /> Удалить из списка
                </Button>

                <Button
                  type="string"
                  onClick={() =>
                    dispatch(downloadVideos({ videosIds: selected_video }))
                  }
                  disabled={selected_video.length > 0 ? false : true}
                >
                  <SvgDownload />
                  Скачать
                </Button>

                <Button type="string" onClick={selectAllS}>
                  <Ok size="xs" /> Выделить все строки
                </Button>

                <Button
                  type="string"
                  onClick={() => setDisableSearch((v) => !v)}
                >
                  {disableSearch ? (
                    <>
                      <SvgSearch size="xs" title="Включить поиск для спика" />{" "}
                      Вкл. поиск
                    </>
                  ) : (
                    <>
                      <SvgMinusCircle
                        size="xs"
                        title="Отключить поиск для спика"
                      />
                      Откл. поиск
                    </>
                  )}
                </Button>
              </ElementsGroup>
            </div>

            <div className="Songs">
              <Header sort={sort} />

              <div>
                <List
                  type="simple"
                  scroll={{
                    on: true,
                    data: {
                      variant: "white",
                      size: "lg",
                    },
                  }}
                  onClick={toggleSelectedS}
                  content={{ items: getItems(), variant: "none" }}
                  droppableId="2"
                />
              </div>
            </div>
          </>
        )}
        {selectedVideolists.length > 1 && (
          <div style={{ height: 60, width: "100%" }} />
        )}
      </div>
    );
  }
);

export default CurrentVideoList;
